import React, { useEffect } from 'react';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import { useDispatch } from 'react-redux';
import {
  LuUndo,
  LuRedo,
} from 'react-icons/lu';
import { ActionCreators } from 'redux-undo';

export default function Handler() {
  const dispatch = useDispatch();

  // `useEffect` is necessary to ensure the bindings only load once (e.g during hot reload in dev)
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === 'z') {
        dispatch(ActionCreators.undo());
      }
      if (event.ctrlKey && (event.key === 'Z' || event.key === 'y')) {
        dispatch(ActionCreators.redo());
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  });

  return (
    <ToggleButtonGroup size="small" sx={{ ml: 3 }}>
      <ToggleButton value="" title="Undo [ctrl+z]" onClick={() => dispatch(ActionCreators.undo())}>
        <LuUndo size="1.5em" />
      </ToggleButton>
      <ToggleButton value="" title="Redo [ctrl+y]" onClick={() => dispatch(ActionCreators.redo())}>
        <LuRedo size="1.5em" />
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
